import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * query superbill by statement number
 */
export default async function querySuperbillByStatementNo(
  statementNo: string | number,
  onBehalfOf?: string,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/superbill/${statementNo}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
